import { render, staticRenderFns } from "./TranshipmentTransferData.vue?vue&type=template&id=5a68f398"
import script from "./TranshipmentTransferData.vue?vue&type=script&lang=js"
export * from "./TranshipmentTransferData.vue?vue&type=script&lang=js"
import style0 from "./TranshipmentTransferData.vue?vue&type=style&index=0&id=5a68f398&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports